<template>
  <!-- temporary - для скрытия панели при клике outside -->
  <v-navigation-drawer
    v-model="isShowTemplateSelector"
    fixed
    right
    width="160"
    hide-overlay
    temporary
  >
    <h1 class="selector-title">Шаблоны</h1>
    <v-expansion-panels v-model="panelsStates">
      <v-expansion-panel v-for="(template, i) in filteredTemplates" :key="i" class="template-group">
        <v-expansion-panel-header><h2>{{template.title}}</h2></v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-list dense class="template-page-list">
            <v-list-item v-for="page in template.pages" :key="template.name + page.name" @click="onSelectTemplatePage(page)">
              <document-preview 
                  :bottom-title="page.title" 
                  :image="`/templates/${template.name}/${page.name}_preview.png`" 
                  :color="page.template.color"
              ></document-preview>
            </v-list-item>
          </v-list>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-navigation-drawer>
</template>

<script>

const FRONT_URL = process.env.VUE_APP_FRONTEND_URL;

export default {
  name: 'TemplateSelector',
  components: {
    DocumentPreview: () => import('./DocumentPreview'),
  },
  props: {
    heading: {
      type: String,
      default: '',
    },
    filterType: [String, Array],
  },
  data: () => ({
    isShowTemplateSelector: false,
    currentTemplate: {},
    templates: [],
    panelsStates: 0,
  }),
  computed: {
    filteredTemplates() {
      let filter = this.filterType;
      if (!filter?.length) {
        return this.templates;
      }
      filter = Array.isArray(filter) ? filter : [filter];
      return this._.filter(this.templates, t => filter.includes(t.name));
    },
  },
  setup() {
    return {
    };
  },
  created() {
    this.loadTemplatesList();
  },
  methods: {
    show() {
        this.isShowTemplateSelector = true;
    },
    close() {
        this.isShowTemplateSelector = false;
    },
    parseTemplatesList(list) {
      this.templates = this._.map(list.templates, t => ({...t, pages: this._.map(t.pages, p => ({...p, template: {...this._.omit(t, ['pages'])}}))}));
      if (this.filteredTemplates.length) {
        this.panelsStates = 0;
      }
    },
    loadTemplatesList() {
      return this.$api.request({
          baseURL: FRONT_URL,
          url: '/templates/index.json',
          method: 'get',
          responseType: 'json',
          maxContentLength: 10000000,
          headers: { 'Content-Type': 'application/json' },
      }).then(response => {
        this.notifySuccess(`Загружен список шаблонов`);
        this.parseTemplatesList(response.data);
      }).catch(this.notifyError);
    },
    parseHtmlAsset(html) {
        const parser = new DOMParser();
        const htmlDoc = parser.parseFromString(html, 'text/html');
        const res = htmlDoc.body.dataset || {};
        if (!htmlDoc.body?.children?.length) {
            return res;
        }
        return this._.merge(
            res, 
            this._(htmlDoc.body?.children)
                    .map(v => ({name: v.tagName.toLowerCase(), html: v.innerHTML}))
                    .keyBy('name')
                    .mapValues('html')
                    .value()
        );
    },
    loadTemplateAssets(template, page) {
        return this.$api.request({
            baseURL: FRONT_URL,
            url: `/templates/${template}/${page}.html`,
            method: 'get',
            responseType: 'text',
            maxContentLength: 10000000,
            headers: { 'Content-Type': 'text/html' },
        }).then(response => {
            return this.parseHtmlAsset(response.data);
        });
    },
    onSelectTemplatePage(page) {
        this.currentTemplate = page;
        this.loadTemplateAssets(page.template.name, page.name).then(assets => {
            this.currentTemplate.parts = assets;
            this.$emit('selected', this.currentTemplate);
            this.close();
        });
    },
  },
}
</script>
<style lang="scss">
  .selector-title {
    background: #57b8d1;
    color: #fff;
    text-align: left;
    padding: 10px;
    font-size: 18px;
    font-weight: 600;
    padding: 8px 10px;
  }
  .template-group {
  }
  .v-expansion-panels {
    .v-expansion-panel-content__wrap {
      padding: 0 0px 16px;
    }
    .v-expansion-panel-header { 
      min-height: 34px;
      padding: 10px;
    }
  }
  
  .v-expansion-panel--active {
    & > .v-expansion-panel-header {
      min-height: 34px;
      padding: 10px;
    }
    &:not(:first-child), 
    & + .v-expansion-panel {
        margin-top: 0;
    }
  }
  .v-list {
    .v-list-item {
      padding: 0 10px;
      &.theme--light:hover {
        &::before {
          opacity: 0;
        }
        .v-card:not(.v-sheet--outlined) {
          box-shadow: 0 0 15px 3px rgba(165, 14, 45, 0.3) !important
        }
      }
    }
  }
  .template-page-list {
    display: flex;
    flex-direction: column;
    row-gap: 10px;
    padding: 10px 0;
  }
  h2 {
    font-size: 18px;
  }
</style>